import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from "react";
export var RedocStepByStepContext = /*#__PURE__*/React.createContext({
  operationsResults: {},
  updateOperationResult: function updateOperationResult() {}
});

var StepByStepWrapper = function StepByStepWrapper(_ref) {
  var a = _ref.children,
      _ref$initialOperation = _ref.initialOperationsResults,
      b = _ref$initialOperation === void 0 ? {} : _ref$initialOperation;

  var _React$useState = React.useState(b),
      c = _React$useState[0],
      d = _React$useState[1];

  return /*#__PURE__*/React.createElement(RedocStepByStepContext.Provider, {
    value: {
      operationsResults: c,
      updateOperationResult: function updateOperationResult(a, b) {
        return d(function (c) {
          var _objectSpread2;

          return _objectSpread(_objectSpread({}, c), {}, (_objectSpread2 = {}, _objectSpread2[a] = b, _objectSpread2));
        });
      }
    }
  }, a);
};

export default StepByStepWrapper;